import { render, staticRenderFns } from "./ModalEditProduct.vue?vue&type=template&id=68b25e62&scoped=true&"
import script from "./ModalEditProduct.vue?vue&type=script&lang=js&"
export * from "./ModalEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditProduct.vue?vue&type=style&index=0&id=68b25e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b25e62",
  null
  
)

export default component.exports